import { ShopOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import { useCallback } from 'react';
import FormFields from '../../../themes/admin/Fields/FormFields';
import { type FormItemProps } from '../FormItem';
import { type SelectFieldProps } from '../SelectField';
import { type TranslationDrawerProps } from '../TranslatedInputField/TranslationDrawer';
import { usePriceDisclaimerDrawer } from './PriceDisclaimerMultipleEntryDrawer';

export type DealershipMarketInputFieldProps = Pick<
    SelectFieldProps,
    'options' | 'name' | 'disabled' | 'label' | 'itemProps'
> &
    Pick<TranslationDrawerProps, 'languages'> & {
        isEdit?: boolean;
        isMultipleEntry?: boolean;
        tooltip?: FormItemProps['tooltip'];
    };

const PriceDisclaimerField = ({
    name,
    disabled,
    languages,
    options,
    isEdit,
    ...props
}: DealershipMarketInputFieldProps) => {
    const drawer = usePriceDisclaimerDrawer();

    const openDrawer = useCallback(() => {
        if (!disabled) {
            drawer.open();
        }
    }, [disabled, drawer]);

    // hide button completely when disable
    const button = disabled ? null : (
        <Button
            icon={<ShopOutlined style={{ color: 'var(--ant-primary-color)' }} />}
            onClick={openDrawer}
            size="small"
            type="text"
        />
    );

    return (
        <>
            <Col onClick={openDrawer}>
                <FormFields.InputField
                    name={`${name}[0].defaultValue`}
                    {...props}
                    addonAfter={button}
                    onClick={openDrawer}
                    style={{ width: '100%' }}
                    disabled
                />
            </Col>
            {drawer.render({ name, title: props.label, options })}
        </>
    );
};

export default PriceDisclaimerField;
